export const selectCurrentLineupsService = (lineupsServices, lineupId) => lineupsServices.filter(ls => ls.lineup_id === lineupId)
  .sort((a, b) => Math.min(a.lcns) - Math.min(b.lcns));
